<template>
  <nuxt-link
    :to="localePath(`/partners/${_id}`)"
    :class="$style.item"
  >
    <div :class="$style.itemThumb">
      <img :src="image" :alt="title" loading="lazy">
    </div>

    <div :class="$style.itemTitle">{{ title }}</div>
    <div :class="$style.caption" v-html="caption" />

    <UiButton
      type="icon"
      :class="$style.action"
    >
      <template #preppendIcon>
        <UiIconsArrowRight />
      </template>
    </UiButton>
  </nuxt-link>
</template>

<script setup lang="ts">
import type { SinglePostParams } from './index.js';
const localePath = useLocalePath();

defineProps<SinglePostParams>();
</script>

<style lang="scss" module>
  .action {
    margin-top: 32px;
  }

  .caption {
    margin-bottom: auto;
  }

  .item {
    flex: 1;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 24px;
    background: #FFF;
    padding: 12px 12px 16px 12px;
    border-radius: 24px;
    border: 1px solid #F0F0F0;
    text-decoration: none;
    color: #596269;
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;

    p {
      margin: 0;
      padding: 0;
    }

    &Title {
      color: #121E29;
      font-family: 'Gilroy';
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 7px;
      margin-top: 18px;
    }

    &Date {
      margin-top: 8px;
      color: #71787F;
      font-size: 14px;
    }

    &Cat {
      z-index: 2;
      position: absolute;
      top: 22px;
      left: 24px;
      display: flex;
      align-items: center;
      gap: 8px;
      height: 28px;
      padding: 7px 12px;
      border-radius: 14px;
      background: rgba(0, 0, 0, 0.15);
      backdrop-filter: blur(7.5px);
      color: #fff;
      font-family: 'Gilroy';
      font-size: 12px;
      font-weight: 400;

      svg {
        flex-shrink: 0;
        width: 10px;
        height: auto;
      }
    }

    &Thumb {
      position: relative;
      border-radius: 24px;
      overflow: hidden;
      height: 250px;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
</style>